module.exports = __webpack_public_path__ + "img/empty2.7a4b7288.png";